import { Controller } from "@hotwired/stimulus"

// Shows a preview of the selected image file in the preview target (img).
// Revokes the object URL on disconnect to avoid leaks.
export default class extends Controller {
  static targets = ["input", "preview"]

  connect() {
    this.objectUrl = null
  }

  disconnect() {
    this.revokeObjectUrl()
  }

  change() {
    this.revokeObjectUrl()
    const file = this.inputTarget?.files?.[0]
    if (!file || !file.type.startsWith("image/")) return
    this.objectUrl = URL.createObjectURL(file)
    if (this.hasPreviewTarget) {
      this.previewTarget.src = this.objectUrl
      this.previewTarget.classList.remove("d-none")
    }
  }

  revokeObjectUrl() {
    if (this.objectUrl) {
      URL.revokeObjectURL(this.objectUrl)
      this.objectUrl = null
    }
  }
}
